/**
 * Top Shop is only available in certain regions, this is used to flag which regions retailers have access
 * to it.
 */ export var TOP_SHOP_RETAILER_EXPERIENCE_ENABLED_BY_REGION_220322 = 'TOP_SHOP_RETAILER_EXPERIENCE_ENABLED_BY_REGION_220322';
